import React from 'react';
import { Grid, Card } from '@mui/material';
import { InfluencerAvatar, InfluencerName } from 'components';
import { InfluencerTypes } from 'api';
import { QueryObserverResult } from '@tanstack/react-query';
import Actions from './Actions';
import InfoRow from './InfoRow';

interface Props {
  data: InfluencerTypes.ItemExtended;
  refetch: () => Promise<QueryObserverResult>;
  inline?: boolean;
}

const Header = (props: Props): JSX.Element => {
  const { data, refetch, inline } = props;

  if (inline) {
    return (
      <Grid
        container
        columnGap={2}
        alignItems="center"
        wrap="nowrap"
        sx={{ p: 2 }}
      >
        <Grid item>
          <InfluencerAvatar data={data} />
        </Grid>
        <Grid item sx={{ flexGrow: 1 }}>
          <InfluencerName
            data={data}
            TypographyProps={{ variant: 'h6' }}
            withSocialNetworkSelect
          />
          <InfoRow data={data} />
        </Grid>
      </Grid>
    );
  }

  return (
    <Card sx={{ p: 3 }}>
      <Grid container columnGap={4} alignItems="center">
        <Grid item>
          <InfluencerAvatar data={data} />
        </Grid>
        <Grid item sx={{ flexGrow: 1 }}>
          <Grid container columnGap={2} alignItems="baseline" mb={2}>
            <Grid item sx={{ flexGrow: 1 }}>
              <InfluencerName
                data={data}
                TypographyProps={{ variant: 'h6' }}
                withSocialNetworkSelect
              />
            </Grid>
            <Grid item>
              <Actions data={data} refetch={refetch} />
            </Grid>
          </Grid>
          <InfoRow data={data} />
        </Grid>
      </Grid>
    </Card>
  );
};

export default Header;
